import { cn as m } from "../../../lib/shadcn/utils/utils.js";
import { jsx as s } from "react/jsx-runtime";
var x = ({ name: a, className: r, variant: e = "box", children: d, dataTestid: o, ...t }) => /* @__PURE__ */ s("div", {
  className: m({
    box: e === "box",
    elevated: e === "elevated"
  }, r),
  "data-testid": o || `card-${a}`,
  ...t,
  children: d
});
x.displayName = "Card";
export {
  x as Card
};

//# sourceMappingURL=Card.js.map